import React from 'react';
import { FaGoogleWallet, FaHome, FaUser } from 'react-icons/fa';
import { BiTransfer } from 'react-icons/bi';
import { GoSignOut } from 'react-icons/go';
import { FiSettings } from 'react-icons/fi';
import OrderHistoryContainer from '../containers/OrderHistoryContainer';
import TransactionHistoryContainer from '../containers/TransactionHistoryContainer';
import OrderTransactionHistory from '../containers/OrderTransactionHistoryContainer';
import AdminManagementContainer from '../containers/AdminManagementContainer';
import PermissionManagementContainer from '../containers/PermissionManagementContainer';
// import PermissionActionManagementContainer from '../containers/PermissionActionManagementContainer';
import ListUserContainer from '../containers/ListUserContainer';
import SettingFeeTransaction from '../containers/SettingFeeTransactionContainer';
import ListCoinOnFieldContainer from '../containers/ListCoinOnFieldContainer';
import ToolsContainer from '../containers/ToolsContainer';
import TransferMoneyContainer from '../containers/TransferMoneyContainer';
import TransactionVerifyContainer from '../containers/TransactionVerifyContainer';

import {
  InOutOrderTransContainer,
  InOutTransContainer,
  InOutTransExternalContainer,
  WalletBalanceContainer,
} from '../containers/StatisticContainer';
import AffilateSettingContainer from '../containers/AffilateSettingContainer';
import AdminWalletBalanceContainer from '../containers/AdminWalletBalanceContainer';
import CampaignContainer from '../containers/CampaignContainer';
import NotificationContainer from '../containers/NotificationContainer';
import LoginSetting from '../containers/ShowCryptoSettingsContainer';

import HomeContainner from '../containers/HomeContainer';
// import RoleManagementContainer from '../containers/RoleManagementContainer';
import TransactionErrorContainer from '../containers/TransactionErrorContainer';
import consts from '../consts';
import AffiliateStatistic from '../containers/AffilateStatisticContainer';

const routes = [
  {
    title: 'Thống kê',
    icon: () => <FiSettings />,
    children: [
      {
        title: 'Biểu đồ',
        icon: () => <FaHome />,
        path: '/',
        isExact: true,
        component: () => <HomeContainner />,
        permissions: [
          consts.AUTH.STATISTIC__EXT_TRANS,
          consts.AUTH.STATISTIC__TRANS,
          consts.AUTH.STATISTIC__ORDER_TRANS,
        ],
      },
      {
        title: 'Giao dịch',
        path: '/statistic/inout-order-trans',
        isExact: true,
        component: () => <InOutOrderTransContainer />,
        permissions: [
          consts.AUTH.STATISTIC__INOUT_ORDER_TRANS,
          consts.AUTH.STATISTIC__INOUT_ORDER_TRANS_CHART,
        ],
      },
      {
        title: 'Nạp rút',
        path: '/statistic/inout-trans',
        isExact: true,
        component: () => <InOutTransContainer />,
        permissions: [
          consts.AUTH.STATISTIC__INOUT_TRANS_CHART,
          consts.AUTH.STATISTIC__INOUT_TRANS,
        ],
      },
      {
        title: 'Giao dịch ngoài sàn',
        path: '/statistic/inout-trans-external',
        isExact: true,
        component: () => <InOutTransExternalContainer />,
        permissions: [
          consts.AUTH.STATISTIC__INOUT_TRANS_EXTERNAL,
          consts.AUTH.STATISTIC__INOUT_TRANS_EXTERNAL_CHART,
        ],
      },
      {
        title: 'Thông tin giới thiệu',
        path: '/statistic/affiliate-statistic',
        isExact: false,
        component: () => <AffiliateStatistic />,
        permissions: [
          consts.AUTH.COMMISSION__USER,
          consts.AUTH.COMMISSION,
          consts.AUTH.COMMISSION__TOTAL_REFERRALS,
          consts.AUTH.FAVORITE__AFFILIATE,
        ],
      },
      {
        title: 'Số dư ví',
        path: '/statistic/wallet-balance',
        isExact: true,
        component: () => <WalletBalanceContainer />,
        permissions: [
          consts.AUTH.STATISTIC__WALLET_BALANCE,
        ],
      },
    ],
  },
  {
    title: 'Quản lý giao dịch',
    icon: () => <FaGoogleWallet />,
    children: [
      {
        title: 'Lịch sử lệnh',
        path: '/order/orders',
        isExact: false,
        component: () => <OrderHistoryContainer />,
        permissions: [
          consts.AUTH.ORDER__RANGE_FILTER,
        ],
      },
      {
        title: 'Lịch sử giao dịch lệnh',
        path: '/order-transaction/all',
        isExact: false,
        component: () => <OrderTransactionHistory />,
        permissions: [
          consts.AUTH.ORDER_TRANSACTION__ALL,
        ],
      },
      {
        title: 'Lịch sử nạp rút',
        icon: () => <BiTransfer />,
        path: '/transaction/history',
        isExact: false,
        component: () => <TransactionHistoryContainer />,
        permissions: [
          consts.AUTH.TRANSACTION__HISTORY_FILTER,
        ],
      },
      {
        title: 'Giao dịch lỗi chưa xử lý',
        icon: () => <BiTransfer />,
        path: '/transaction/tx-error',
        isExact: false,
        component: () => <TransactionErrorContainer />,
        permissions: [
          consts.AUTH.TRANSACTION__TX_ERROR,
        ],
      },
    ],
  },
  {
    title: 'Quản lý người dùng',
    icon: () => <GoSignOut />,
    children: [
      {
        title: 'Danh sách người dùng',
        path: '/user/paginate',
        isExact: false,
        component: () => <ListUserContainer />,
        permissions: [
          consts.AUTH.USER__PAGINATE,
          consts.AUTH.USER__LIST_INFO,
        ],
      },
      {
        title: 'Tìm kiếm theo địa chỉ coin',
        path: '/tool/trace-address',
        isExact: true,
        component: () => <ToolsContainer />,
        permissions: [
          consts.AUTH.TOOLS__USER_BY_ADDRESS,
        ],
      },
    ],
  },
  {
    title: 'Công cụ quản trị',
    icon: () => <FaUser />,
    children: [
      {
        title: 'Chuyển tiền',
        path: '/tool/transfer-money',
        isExact: false,
        component: () => <TransferMoneyContainer />,
        permissions: [
          consts.AUTH.SETTING__LIMIT_WITHDRAWAL,
          consts.AUTH.TRANSACTION__LIMIT_24H,
          consts.AUTH.TRANSACTION__HISTORY,
        ],
      },
      {
        title: 'Số dư ví admin',
        path: '/tool/admin-wallet-balance',
        isExact: true,
        component: () => <AdminWalletBalanceContainer />,
        permissions: [
          consts.AUTH.MANAGER__ADMIN_WALLETS,
          consts.AUTH.MANAGER__ERR_ERC20,
        ],
      },
      {
        title: 'Chiến dịch',
        path: '/tool/campaign',
        isExact: true,
        component: () => <CampaignContainer />,
        permissions: [
          consts.AUTH.CAMPAIGN__PAGINATE,
        ],
      },
      {
        title: 'Thông báo',
        path: '/tool/notification',
        isExact: true,
        component: () => <NotificationContainer />,
        permissions: [
          consts.AUTH.ADMINNOTIFICATION_PAGINATE,
        ],
      },
      {
        title: 'Kiểm tra giao dịch',
        path: '/tool/transaction-verify',
        isExact: true,
        component: () => <TransactionVerifyContainer />,
        permissions: [
          consts.AUTH.TRANSACTION__VERIFY,
          consts.AUTH.TOOLS__USER_BY_ADDRESS,
        ],
      },
    ],
  },
  {
    title: 'Quản trị viên',
    icon: () => <FaUser />,
    children: [
      {
        title: 'Danh sách quản trị viên',
        path: '/admin/all-admins',
        isExact: false,
        component: () => <AdminManagementContainer />,
        permissions: [
          consts.AUTH.MANAGER__ALL_ADMINS,
        ],
      },
      // {
      //   title: 'Chi tiết phân quyền',
      //   path: '/authorization/roles',
      //   isExact: false,
      //   component: () => <RoleManagementContainer />,
      //   permissions: [consts.AUTH.AUTHORIZATION__ROLES],
      // },
      {
        title: 'Quản lý các quyền',
        path: '/authorization/permissions',
        isExact: false,
        component: () => <PermissionManagementContainer />,
        permissions: [consts.AUTH.AUTHORIZATION__PERMISSIONS],
      },
      // {
      //   title: 'Quản lý hành động quyền',
      //   path: '/authorization/controls',
      //   isExact: false,
      //   component: () => <PermissionActionManagementContainer />,
      //   permissions: [consts.AUTH.AUTHORIZATION__CONTROLS],
      // },
    ],
  },
  {
    title: 'Thiết lập',
    icon: () => <FiSettings />,
    children: [
      {
        title: 'Đăng nhập',
        path: '/settings/login',
        isExact: false,
        component: () => <LoginSetting />,
        permissions: [
          consts.AUTH.SETTING__CRYPTOEXCHANGECONFIG,
          consts.AUTH.SETTING__LISTPUBKEYTOACTIVELISTCRYPTOEXCHANGE,
        ],
      },
      {
        title: 'Tiền điện tử',
        path: '/settings/coin',
        isExact: false,
        isPublic: true,
        component: () => <ListCoinOnFieldContainer />,
      },
      {
        title: 'Thị trường',
        icon: () => <FiSettings />,
        path: '/settings/order-fee',
        isExact: false,
        isPublic: true,
        component: () => <SettingFeeTransaction />,
      },
      {
        title: 'Hoa hồng',
        path: '/setting/affiliate-setting',
        isExact: true,
        component: () => <AffilateSettingContainer />,
        permissions: [consts.AUTH.AFFILIATE_ADMIN],
      },
    ],
  },
];

export default routes;
